import React from "react";
import { useQuery } from "@tanstack/react-query";
import { reportService } from "../../services/reports";
import LoadingSpinner from "../Common/LoadingSpinner";

export default function StockReport() {
  const { data, isLoading } = useQuery({
    queryKey: ["stock-report"],
    queryFn: () => reportService.getInventoryReport()
  });

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="text-lg font-semibold mb-4">Inventory Report</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-blue-50 p-3 rounded">
          <p className="text-sm">Total Products</p>
          <p className="text-xl font-bold">{data?.summary?.totalProducts || 0}</p>
        </div>
        <div className="bg-green-50 p-3 rounded">
          <p className="text-sm">Total Stock Value</p>
          <p className="text-xl font-bold">KES {data?.summary?.totalStockValue?.toLocaleString() || 0}</p>
        </div>
        <div className="bg-yellow-50 p-3 rounded">
          <p className="text-sm">Low Stock Items</p>
          <p className="text-xl font-bold text-yellow-600">{data?.summary?.lowStockItems || 0}</p>
        </div>
        <div className="bg-red-50 p-3 rounded">
          <p className="text-sm">Out of Stock</p>
          <p className="text-xl font-bold text-red-600">{data?.summary?.outOfStockItems || 0}</p>
        </div>
      </div>
    </div>
  );
}